import axios from 'axios'

// 创建axios实例
const service = axios.create({
  // 在开发环境中使用 '/api' 作为baseURL，这样会走vue.config.js中的proxy配置
  // 在生产环境中可以通过环境变量配置baseURL
  // baseURL: process.env.NODE_ENV === 'development' ? 'https://zhiwa.zhiwahuishou.com/prod-api/api' : process.env.VUE_APP_BASE_API || 'https://zhiwa.zhiwahuishou.com/prod-api/api/',
  // baseURL: process.env.NODE_ENV === 'development' ? 'http://192.168.0.12:7380/api/' : process.env.VUE_APP_BASE_API || 'http://192.168.0.12:7380/api/',
  // baseURL: process.env.NODE_ENV === 'development' ? 'https://api.admin.bilaiduo.cn/prod-api/api' : process.env.VUE_APP_BASE_API || 'https://api.admin.bilaiduo.cn/prod-api/api/',
  baseURL: process.env.NODE_ENV === 'development' ? 'https://testcompany.zhiwahuishou.com/prod-api/api/' : process.env.VUE_APP_BASE_API || 'https://testcompany.zhiwahuishou.com/prod-api/api/',
  timeout: 5000 // 请求超时时间
})

// export const IMAGE_BASE_URL = 'https://boxstatic.bilaiduo.cn/'
export const IMAGE_BASE_URL = 'https://static.zhiwahuishou.com/'

export default service